import { Injectable, signal } from '@angular/core'
import { Store } from '@ngrx/store'
import { StorageKeys } from '@/app/core/config/storage-keys'
import { LAYOUT_COLOR_TYPES } from '@/app/store/layout/layout'
import { changetheme } from '@/app/store/layout/layout-action'

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly theme = signal(this.readTheme())

  constructor(private readonly store: Store) {
    this.applyTheme(this.theme())
  }

  currentTheme(): string {
    return this.theme()
  }

  toggle(): void {
    this.setTheme(this.theme() === LAYOUT_COLOR_TYPES.LIGHTMODE
      ? LAYOUT_COLOR_TYPES.DARKMODE
      : LAYOUT_COLOR_TYPES.LIGHTMODE)
  }

  setTheme(theme: string): void {
    const nextTheme = theme === LAYOUT_COLOR_TYPES.DARKMODE
      ? LAYOUT_COLOR_TYPES.DARKMODE
      : LAYOUT_COLOR_TYPES.LIGHTMODE

    this.theme.set(nextTheme)
    localStorage.setItem(StorageKeys.THEME, nextTheme)
    this.applyTheme(nextTheme)
    this.store.dispatch(changetheme({ color: nextTheme }))
  }

  private readTheme(): string {
    return localStorage.getItem(StorageKeys.THEME) === LAYOUT_COLOR_TYPES.DARKMODE
      ? LAYOUT_COLOR_TYPES.DARKMODE
      : LAYOUT_COLOR_TYPES.LIGHTMODE
  }

  private applyTheme(theme: string): void {
    document.documentElement.setAttribute('data-bs-theme', theme)
  }
}
